import { render, staticRenderFns } from "./OutboundTransferDestination.template.vue?vue&type=template&id=64c15e5e&scoped=true&"
var script = {}
import style0 from "./OutboundTransferDestination.template.vue?vue&type=style&index=0&id=64c15e5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c15e5e",
  null
  
)

export default component.exports